export default "__VITE_ASSET__DNSE54th__"